import { FC, useCallback, useEffect } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'components/Controls';
import { Button, IconButton } from 'components/Buttons';
import { Tooltip } from 'components/Tooltip';
// Icons
import { FaTrash } from 'react-icons/fa6';
// Utilities
import { isRequired, noWhitespace } from 'utilities/validation';

type Props = {
  questionIndex: number;
  questionRef: string;
}

const CorrectAnswers:FC<Props> = ({ questionIndex, questionRef }) => {
  const { t } = useTranslation();

  const name = `questions[${questionIndex}].config.correctAnswers`;

  const { control, formState:{ errors } } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name
  });

  const onAdd = useCallback(() => {
    append({ title: '' });
  }, [append]);

  const onRemove = (index:number) => () => remove(index);

  useEffect(() => {
    if (fields.length === 0) onAdd();
  }, [fields, onAdd]);


  return (
    <div className="mb-4">
      <div className="mb-2">
        {fields.map((field, index) => (
            <div key={field.id} className="flex-grow">
              <div className="flex gap-4 mb-1">
                <Controller
                  control={control}
                  rules={{ required: isRequired, validate: noWhitespace }}
                  name={`${name}.${index}.title`}
                  render={({ field }) => (
                    <Input
                      {...field}
                      className="mb-0 flex-grow"
                      id={`${name}.${index}`}
                      label={`${t('labels.answer')} ${index + 1}`}
                      required
                      error={!!errors?.questions?.[questionIndex]?.config?.correctAnswers?.[index]}
                      errorText={errors?.questions?.[questionIndex]?.config?.correctAnswers?.[index]?.message}
                    />
                  )}
                />
                {index > 0 ? (
                  <div className="mt-6">
                    <Tooltip title={t('buttons.removeAnswer')}>
                      <IconButton
                        onClick={onRemove(index)}
                        ><FaTrash /></IconButton>
                    </Tooltip>
                  </div>
                ) : null}
              </div>
              <span className="divider"></span>
            </div>
          ))}
      </div>
      <Button onClick={onAdd} variant="contained">
        {t('buttons.addAnswer')}
      </Button>
    </div>
  )
}

export default CorrectAnswers;
